export default function WorkspaceActions({ exportBallot, exportPdf, isPro, saveBallot }) {
  return (
    <div className="workspace-actions" data-testid="pro-workspace-actions">
      {!isPro && (
        <p className="pro-actions-locked" data-testid="pro-actions-locked-message">
          Saved round history and ballot exports are available with Pro.
        </p>
      )}
      <button
        className="secondary-action"
        onClick={exportBallot}
        disabled={!isPro}
        data-testid="export-ballot-button"
      >
        Export notes
      </button>
      <button
        className="primary-action"
        onClick={saveBallot}
        disabled={!isPro}
        data-testid="save-ballot-button"
      >
        Save to history
      </button>
      <button
        className="secondary-action"
        onClick={exportPdf}
        disabled={!isPro}
        data-testid="export-complete-pdf-button"
      >
        Export complete PDF
      </button>
    </div>
  );
}